(() => {
  const translations = {
    de: {
      heading: 'Anfrage zu Verfügbarkeit und Angebot',
      product: 'Produkt',
      variant: 'Variante',
      sku: 'Artikelnummer',
      variantId: 'Varianten-ID',
      url: 'Produkt-URL',
      details: 'Bitte ergänzen Sie hier weitere Angaben:'
    },
    en: {
      heading: 'Availability and quotation request',
      product: 'Product',
      variant: 'Variant',
      sku: 'SKU',
      variantId: 'Variant ID',
      url: 'Product URL',
      details: 'Please add any further details here:'
    },
    fr: {
      heading: 'Demande de disponibilité et de devis',
      product: 'Produit',
      variant: 'Variante',
      sku: 'Référence',
      variantId: 'ID de variante',
      url: 'URL du produit',
      details: 'Ajoutez ici toute information complémentaire :'
    },
    it: {
      heading: 'Richiesta di disponibilità e preventivo',
      product: 'Prodotto',
      variant: 'Variante',
      sku: 'Codice articolo',
      variantId: 'ID variante',
      url: 'URL del prodotto',
      details: 'Aggiungi qui eventuali informazioni aggiuntive:'
    },
    nl: {
      heading: 'Aanvraag voor beschikbaarheid en offerte',
      product: 'Product',
      variant: 'Variant',
      sku: 'Artikelnummer',
      variantId: 'Variant-ID',
      url: 'Product-URL',
      details: 'Voeg hier eventuele aanvullende informatie toe:'
    },
    pt: {
      heading: 'Pedido de disponibilidade e orçamento',
      product: 'Produto',
      variant: 'Variante',
      sku: 'Referência',
      variantId: 'ID da variante',
      url: 'URL do produto',
      details: 'Adicione aqui qualquer informação adicional:'
    },
    ca: {
      heading: 'Sol·licitud de disponibilitat i pressupost',
      product: 'Producte',
      variant: 'Variant',
      sku: 'Referència',
      variantId: 'ID de variant',
      url: 'URL del producte',
      details: 'Afegeix aquí qualsevol informació addicional:'
    },
    es: {
      heading: 'Solicitud de disponibilidad y presupuesto',
      product: 'Producto',
      variant: 'Variante',
      sku: 'SKU',
      variantId: 'ID de variante',
      url: 'URL del producto',
      details: 'Indique aquí cualquier detalle adicional:'
    }
  };

  const addHiddenField = (form, name, value) => {
    if (!value) return;

    let input = form.querySelector(`input[type="hidden"][name="${CSS.escape(name)}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const prefill = (root = document) => {
    const params = new URLSearchParams(window.location.search);
    const product = params.get('product')?.trim() || '';
    if (!product) return;

    const locale = (document.documentElement.lang || 'es').toLowerCase().split('-')[0];
    const text = translations[locale] || translations.es;
    const variant = params.get('variant')?.trim() || '';
    const sku = params.get('sku')?.trim() || '';
    const variantId = params.get('variant_id')?.trim() || '';
    const source = params.get('source')?.trim() || '';
    const productUrl = source ? new URL(source, window.location.origin).href : '';

    root.querySelectorAll?.('.contact-form__form').forEach((form) => {
      addHiddenField(form, 'contact[Producto solicitado]', product);
      addHiddenField(form, 'contact[Variante solicitada]', variant);
      addHiddenField(form, 'contact[SKU solicitado]', sku);
      addHiddenField(form, 'contact[ID de variante]', variantId);
      addHiddenField(form, 'contact[URL de producto]', productUrl);

      const textarea = form.querySelector('textarea[name="contact[body]"]');
      if (!(textarea instanceof HTMLTextAreaElement) || textarea.value.trim()) return;

      const lines = [
        text.heading,
        '',
        `${text.product}: ${product}`,
        variant ? `${text.variant}: ${variant}` : '',
        sku ? `${text.sku}: ${sku}` : '',
        variantId ? `${text.variantId}: ${variantId}` : '',
        productUrl ? `${text.url}: ${productUrl}` : '',
        '',
        text.details,
        ''
      ].filter((line, index, values) => line || values[index - 1] !== '');

      textarea.value = lines.join('\n');
    });
  };

  if (window.__ibContactRequestPrefillInitialized) {
    prefill();
    return;
  }

  window.__ibContactRequestPrefillInitialized = true;
  window.__ibPrefillContactRequests = prefill;

  document.addEventListener('shopify:section:load', (event) => prefill(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prefill(), { once: true });
  } else {
    prefill();
  }
})();
